import { createClient } from '@supabase/supabase-js';
import { Database } from '@shared/database';

// Trim the env values. Dashboard-managed env vars (e.g. Vercel) frequently pick
// up a trailing newline/space when pasted. supabase-js sanitises a stray newline
// in REST request HEADERS (so REST/auth/storage keep working) but NOT when it
// builds the realtime WebSocket URL — there a trailing "\n" encodes to "%0A" and
// silently KILLS the realtime connection (live generation status + notifications
// go dark, which reads as an outage even though REST is fine). Trim so the client
// is whitespace-proof regardless of how the env var was entered.
const rawSupabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const rawSupabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();

// Flag used by the UI to show a helpful message instead of crashing
export const isSupabaseConfigMissing = !rawSupabaseUrl || !rawSupabaseKey;

// Fallback values keep the client constructable so imports don't throw
// when env vars are missing. The app should gate on isSupabaseConfigMissing
// and avoid making real requests in this state.
const supabaseUrl = rawSupabaseUrl || 'http://localhost';
const supabaseKey = rawSupabaseKey || 'public-anon-key';

export const supabase = createClient<Database>(supabaseUrl, supabaseKey);
